"use strict";
/*
 * HSDropdown
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var core_1 = require("@popperjs/core");
var base_plugin_1 = __importDefault(require("../base-plugin"));
var constants_1 = require("../../constants");
var HSDropdown = /** @class */ (function (_super) {
    __extends(HSDropdown, _super);
    function HSDropdown(el, options, events) {
        var _this = _super.call(this, el, options, events) || this;
        _this.toggle =
            _this.el.querySelector(':scope > .hs-dropdown-toggle') ||
                _this.el.querySelector(':scope > .hs-dropdown-toggle-wrapper > .hs-dropdown-toggle') ||
                _this.el.children[0];
        _this.closers =
            Array.from(_this.el.querySelectorAll(':scope .hs-dropdown-close')) || null;
        _this.menu = _this.el.querySelector(':scope > .hs-dropdown-menu');
        _this.eventMode = (0, utils_1.getClassProperty)(_this.el, '--trigger', 'click');
        _this.closeMode = (0, utils_1.getClassProperty)(_this.el, '--auto-close', 'true');
        _this.animationInProcess = false;
        if (_this.toggle && _this.menu)
            _this.init();
        return _this;
    }
    HSDropdown.prototype.init = function () {
        var _this = this;
        this.createCollection(window.$hsDropdownCollection, this);
        if (this.toggle.disabled)
            return false;
        if (this.toggle)
            this.buildToggle();
        if (this.menu)
            this.buildMenu();
        if (this.closers)
            this.buildClosers();
        if (!(0, utils_1.isIOS)() && !(0, utils_1.isIpadOS)()) {
            this.el.addEventListener('mouseenter', function () { return _this.onMouseEnterHandler(); });
            this.el.addEventListener('mouseleave', function () { return _this.onMouseLeaveHandler(); });
        }
    };
    HSDropdown.prototype.resizeHandler = function () {
        this.eventMode = (0, utils_1.getClassProperty)(this.el, '--trigger', 'click');
        this.closeMode = (0, utils_1.getClassProperty)(this.el, '--auto-close', 'true');
    };
    HSDropdown.prototype.buildToggle = function () {
        var _this = this;
        var _a;
        if ((_a = this === null || this === void 0 ? void 0 : this.toggle) === null || _a === void 0 ? void 0 : _a.ariaExpanded) {
            if (this.el.classList.contains('open'))
                this.toggle.ariaExpanded = 'true';
            else
                this.toggle.ariaExpanded = 'false';
        }
        this.toggle.addEventListener('click', function (evt) { return _this.onClickHandler(evt); });
    };
    HSDropdown.prototype.buildMenu = function () {
        this.menu.role = 'menu';
    };
    HSDropdown.prototype.buildClosers = function () {
        var _this = this;
        this.closers.forEach(function (el) {
            el.addEventListener('click', function () { return _this.close(); });
        });
    };
    HSDropdown.prototype.onClickHandler = function (evt) {
        if (this.el.classList.contains('open') &&
            !this.menu.classList.contains('hidden')) {
            this.close();
        }
        else {
            this.open();
        }
    };
    HSDropdown.prototype.onMouseEnterHandler = function () {
        if (this.eventMode !== 'hover')
            return false;
        if (this.el._popper)
            this.forceClearState();
        if (!this.el.classList.contains('open') &&
            this.menu.classList.contains('hidden')) {
            this.open();
        }
    };
    HSDropdown.prototype.onMouseLeaveHandler = function () {
        if (this.eventMode !== 'hover')
            return false;
        if (this.el.classList.contains('open') &&
            !this.menu.classList.contains('hidden')) {
            this.close();
        }
    };
    HSDropdown.prototype.destroyPopper = function () {
        this.menu.classList.remove('block');
        this.menu.classList.add('hidden');
        this.menu.style.inset = null;
        this.menu.style.position = null;
        if (this.el && this.el._popper)
            this.el._popper.destroy();
        this.animationInProcess = false;
    };
    HSDropdown.prototype.absoluteStrategyModifiers = function () {
        var _this = this;
        return [
            {
                name: 'applyStyles',
                fn: function (data) {
                    var strategy = (window.getComputedStyle(_this.el).getPropertyValue('--strategy') ||
                        'absolute').replace(' ', '');
                    var adaptive = (window.getComputedStyle(_this.el).getPropertyValue('--adaptive') ||
                        'adaptive').replace(' ', '');
                    data.state.elements.popper.style.position = strategy;
                    data.state.elements.popper.style.transform =
                        adaptive === 'adaptive' ? data.state.styles.popper.transform : null;
                    data.state.elements.popper.style.top = null;
                    data.state.elements.popper.style.bottom = null;
                    data.state.elements.popper.style.left = null;
                    data.state.elements.popper.style.right = null;
                    data.state.elements.popper.style.margin = 0;
                },
            },
        ];
    };
    // Public methods
    HSDropdown.prototype.open = function () {
        var _this = this;
        if (this.el.classList.contains('open'))
            return false;
        if (this.animationInProcess)
            return false;
        this.animationInProcess = true;
        var placement = (window.getComputedStyle(this.el).getPropertyValue('--placement') || '').replace(' ', '');
        var flip = (window.getComputedStyle(this.el).getPropertyValue('--flip') || 'true').replace(' ', '');
        var strategy = (window.getComputedStyle(this.el).getPropertyValue('--strategy') || 'fixed').replace(' ', '');
        var offset = parseInt((window.getComputedStyle(this.el).getPropertyValue('--offset') || '10').replace(' ', ''));
        var gpuAcceleration = (window.getComputedStyle(this.el).getPropertyValue('--gpu-acceleration') ||
            'true').replace(' ', '');
        if (strategy !== 'static') {
            this.el._popper = (0, core_1.createPopper)(this.el, this.menu, {
                placement: constants_1.POSITIONS[placement] || 'bottom-start',
                strategy: strategy,
                modifiers: __spreadArray(__spreadArray([], (strategy !== 'fixed' ? this.absoluteStrategyModifiers() : []), true), [
                    {
                        name: 'flip',
                        enabled: flip === 'true',
                    },
                    {
                        name: 'offset',
                        options: {
                            offset: [0, offset],
                        },
                    },
                    {
                        name: 'computeStyles',
                        options: {
                            adaptive: strategy !== 'fixed' ? false : true,
                            gpuAcceleration: gpuAcceleration === 'true' ? true : false,
                        },
                    },
                ], false),
            });
        }
        this.menu.style.margin = null;
        this.menu.classList.remove('hidden');
        this.menu.classList.add('block');
        setTimeout(function () {
            var _a;
            if ((_a = _this === null || _this === void 0 ? void 0 : _this.toggle) === null || _a === void 0 ? void 0 : _a.ariaExpanded)
                _this.toggle.ariaExpanded = 'true';
            _this.el.classList.add('open');
            _this.animationInProcess = false;
        });
        this.fireEvent('open', this.el);
        (0, utils_1.dispatch)('open.hs.dropdown', this.el, this.el);
    };
    HSDropdown.prototype.close = function (isAnimated) {
        var _this = this;
        if (isAnimated === void 0) { isAnimated = true; }
        if (this.animationInProcess || !this.el.classList.contains('open'))
            return false;
        var clearAfterClose = function () {
            var _a;
            _this.menu.style.margin = null;
            if ((_a = _this === null || _this === void 0 ? void 0 : _this.toggle) === null || _a === void 0 ? void 0 : _a.ariaExpanded)
                _this.toggle.ariaExpanded = 'false';
            _this.el.classList.remove('open');
            _this.fireEvent('close', _this.el);
            (0, utils_1.dispatch)('close.hs.dropdown', _this.el, _this.el);
        };
        this.animationInProcess = true;
        if (isAnimated) {
            var el = this.el.querySelector('[data-hs-dropdown-transition]') || this.menu;
            (0, utils_1.afterTransition)(el, function () { return _this.destroyPopper(); });
        }
        else
            this.destroyPopper();
        clearAfterClose();
    };
    HSDropdown.prototype.forceClearState = function () {
        this.destroyPopper();
        this.menu.style.margin = null;
        this.el.classList.remove('open');
    };
    // Static methods
    HSDropdown.getInstance = function (target, isInstance) {
        var elInCollection = window.$hsDropdownCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        return elInCollection
            ? isInstance
                ? elInCollection
                : elInCollection.element.el
            : null;
    };
    HSDropdown.autoInit = function () {
        if (!window.$hsDropdownCollection)
            window.$hsDropdownCollection = [];
        document
            .querySelectorAll('.hs-dropdown:not(.--prevent-on-load-init)')
            .forEach(function (el) {
            if (!window.$hsDropdownCollection.find(function (elC) { var _a; return ((_a = elC === null || elC === void 0 ? void 0 : elC.element) === null || _a === void 0 ? void 0 : _a.el) === el; }))
                new HSDropdown(el);
        });
        if (window.$hsDropdownCollection) {
            document.addEventListener('keydown', function (evt) {
                return HSDropdown.accessibility(evt);
            });
            window.addEventListener('click', function (evt) {
                var evtTarget = evt.target;
                HSDropdown.closeCurrentlyOpened(evtTarget);
            });
            var prevWidth_1 = window.innerWidth;
            window.addEventListener('resize', function () {
                if (window.innerWidth !== prevWidth_1) {
                    prevWidth_1 = innerWidth;
                    HSDropdown.closeCurrentlyOpened(null, false);
                }
            });
        }
    };
    HSDropdown.open = function (target) {
        var elInCollection = window.$hsDropdownCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        if (elInCollection &&
            elInCollection.element.menu.classList.contains('hidden'))
            elInCollection.element.open();
    };
    HSDropdown.close = function (target) {
        var elInCollection = window.$hsDropdownCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        if (elInCollection &&
            !elInCollection.element.menu.classList.contains('hidden')) {
            elInCollection.element.close();
        }
    };
    // Accessibility methods
    HSDropdown.accessibility = function (evt) {
        this.history = utils_1.menuSearchHistory;
        var target = window.$hsDropdownCollection.find(function (el) {
            return el.element.el.classList.contains('open');
        });
        if (target &&
            (constants_1.DROPDOWN_ACCESSIBILITY_KEY_SET.includes(evt.code) ||
                (evt.code.length === 4 &&
                    evt.code[evt.code.length - 1].match(/^[A-Z]*$/))) &&
            !evt.metaKey &&
            !target.element.menu.querySelector('input:focus') &&
            !target.element.menu.querySelector('textarea:focus')) {
            switch (evt.code) {
                case 'Escape':
                    if (!target.element.menu.querySelector('.hs-select.active')) {
                        evt.preventDefault();
                        this.onEscape(evt);
                    }
                    break;
                case 'Enter':
                    if (!target.element.menu.querySelector('.hs-select button:focus') &&
                        !target.element.menu.querySelector('.hs-collapse-toggle:focus')) {
                        this.onEnter(evt);
                    }
                    break;
                case 'ArrowUp':
                    evt.preventDefault();
                    evt.stopImmediatePropagation();
                    this.onArrow();
                    break;
                case 'ArrowDown':
                    evt.preventDefault();
                    evt.stopImmediatePropagation();
                    this.onArrow(false);
                    break;
                case 'Home':
                    evt.preventDefault();
                    evt.stopImmediatePropagation();
                    this.onStartEnd();
                    break;
                case 'End':
                    evt.preventDefault();
                    evt.stopImmediatePropagation();
                    this.onStartEnd(false);
                    break;
                default:
                    evt.preventDefault();
                    this.onFirstLetter(evt.key);
                    break;
            }
        }
    };
    HSDropdown.onEscape = function (evt) {
        var dropdown = evt.target.closest('.hs-dropdown.open');
        if (window.$hsDropdownCollection.find(function (el) { return el.element.el === dropdown; })) {
            var target = window.$hsDropdownCollection.find(function (el) { return el.element.el === dropdown; });
            if (target) {
                target.element.close();
                target.element.toggle.focus();
            }
        }
        else {
            this.closeCurrentlyOpened();
        }
    };
    HSDropdown.onEnter = function (evt) {
        var dropdown = evt.target.parentElement;
        if (window.$hsDropdownCollection.find(function (el) { return el.element.el === dropdown; })) {
            evt.preventDefault();
            var target = window.$hsDropdownCollection.find(function (el) { return el.element.el === dropdown; });
            if (target)
                target.element.open();
        }
    };
    HSDropdown.onArrow = function (isArrowUp) {
        if (isArrowUp === void 0) { isArrowUp = true; }
        var target = window.$hsDropdownCollection.find(function (el) {
            return el.element.el.classList.contains('open');
        });
        if (target) {
            var menu = target.element.menu;
            if (!menu)
                return false;
            var preparedLinks = isArrowUp
                ? Array.from(menu.querySelectorAll('a:not([hidden]), .hs-dropdown > button:not([hidden])')).reverse()
                : Array.from(menu.querySelectorAll('a:not([hidden]), .hs-dropdown > button:not([hidden])'));
            var links = preparedLinks.filter(function (el) { return !el.classList.contains('disabled'); });
            var current_1 = menu.querySelector('a:focus, button:focus');
            var currentInd = links.findIndex(function (el) { return el === current_1; });
            if (currentInd + 1 < links.length) {
                currentInd++;
            }
            links[currentInd].focus();
        }
    };
    HSDropdown.onStartEnd = function (isStart) {
        if (isStart === void 0) { isStart = true; }
        var target = window.$hsDropdownCollection.find(function (el) {
            return el.element.el.classList.contains('open');
        });
        if (target) {
            var menu = target.element.menu;
            if (!menu)
                return false;
            var preparedLinks = isStart
                ? Array.from(menu.querySelectorAll('a'))
                : Array.from(menu.querySelectorAll('a')).reverse();
            var links = preparedLinks.filter(function (el) { return !el.classList.contains('disabled'); });
            if (links.length) {
                links[0].focus();
            }
        }
    };
    HSDropdown.onFirstLetter = function (code) {
        var _this = this;
        var target = window.$hsDropdownCollection.find(function (el) {
            return el.element.el.classList.contains('open');
        });
        if (target) {
            var menu = target.element.menu;
            if (!menu)
                return false;
            var links_1 = Array.from(menu.querySelectorAll('a'));
            var getCurrentInd = function () {
                return links_1.findIndex(function (el, i) {
                    return el.innerText.toLowerCase().charAt(0) === code.toLowerCase() &&
                        _this.history.existsInHistory(i);
                });
            };
            var currentInd = getCurrentInd();
            if (currentInd === -1) {
                this.history.clearHistory();
                currentInd = getCurrentInd();
            }
            if (currentInd !== -1) {
                links_1[currentInd].focus();
                this.history.addHistory(currentInd);
            }
        }
    };
    HSDropdown.closeCurrentlyOpened = function (evtTarget, isAnimated) {
        if (evtTarget === void 0) { evtTarget = null; }
        if (isAnimated === void 0) { isAnimated = true; }
        var parent = evtTarget &&
            evtTarget.closest('.hs-dropdown') &&
            evtTarget.closest('.hs-dropdown').parentElement.closest('.hs-dropdown')
            ? evtTarget
                .closest('.hs-dropdown')
                .parentElement.closest('.hs-dropdown')
            : null;
        var currentlyOpened = parent
            ? window.$hsDropdownCollection.filter(function (el) {
                return el.element.el.classList.contains('open') &&
                    el.element.menu
                        .closest('.hs-dropdown')
                        .parentElement.closest('.hs-dropdown') === parent;
            })
            : window.$hsDropdownCollection.filter(function (el) {
                return el.element.el.classList.contains('open');
            });
        if (evtTarget &&
            evtTarget.closest('.hs-dropdown') &&
            (0, utils_1.getClassPropertyAlt)(evtTarget.closest('.hs-dropdown'), '--auto-close') ===
                'inside') {
            currentlyOpened = currentlyOpened.filter(function (el) { return el.element.el !== evtTarget.closest('.hs-dropdown'); });
        }
        if (currentlyOpened) {
            currentlyOpened.forEach(function (el) {
                if (el.element.closeMode === 'false' ||
                    el.element.closeMode === 'outside')
                    return false;
                el.element.close(isAnimated);
            });
        }
    };
    // Backward compatibility
    HSDropdown.on = function (evt, target, cb) {
        var elInCollection = window.$hsDropdownCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        if (elInCollection)
            elInCollection.element.events[evt] = cb;
    };
    return HSDropdown;
}(base_plugin_1.default));
window.addEventListener('load', function () {
    HSDropdown.autoInit();
    // Uncomment for debug
    // console.log('Dropdown collection:', window.$hsDropdownCollection);
});
window.addEventListener('resize', function () {
    if (!window.$hsDropdownCollection)
        window.$hsDropdownCollection = [];
    window.$hsDropdownCollection.forEach(function (el) { return el.element.resizeHandler(); });
});
if (typeof window !== 'undefined') {
    window.HSDropdown = HSDropdown;
}
exports.default = HSDropdown;
